import React from 'react';
import { useZxing } from 'react-zxing';

const BarcodeScannerPage = () => {
  const { ref } = useZxing({
    onResult(result) {
      window.location.href = `/refund/receipt/${result.getText()}`;
    },
  });

  return (
    <div className="p-6">
      <h1 className="text-3xl font-bold text-gray-800 mb-6">Scan Receipt Barcode</h1>
      <video ref={ref} className="w-full max-w-md mx-auto" />
    </div>
  );
};

export default BarcodeScannerPage;
